/**
 * Script de Vídeos Destacados - Divi Phergal
 * 
 * Gestiona la renderización, paginación y navegación de la galería
 * de vídeos destacados. Utiliza vanilla JavaScript puro sin dependencias
 * externas.
 * 
 * Características:
 * - Paginación por filas (página a página)
 * - Responsividad automática según breakpoints CSS
 * - Navegación por teclado (Tab, Enter, Arrow keys)
 * - Soporte para ARIA labels y atributos de accesibilidad
 * - Sin librerías externas: 100% vanilla JS
 * 
 * @package PhergalVideos
 * @since 1.0.0
 */

/**
 * Script de Webinar de formación en formato video - Divi Phergal
 * 
 * Gestiona la renderización, paginación y navegación de la galería
 * de webinars de formacion. Utiliza vanilla JavaScript puro sin dependencias
 * externas.
 * 
 * 
 * @package PhergalVideos
 * @since 1.0.0
 */

(function() {
    'use strict';

	const WebinarGallery = {
		/**
         * Almacena las instancias de carrouseles por ID
         * Permite múltiples galerías independientes en la misma página
         * @type {Object}
         */
        instances: {},

        /**
         * Configuración de breakpoints que coinciden con los CSS
         * Se comprueba con matchMedia para determinar el layout actual
         */
        breakpoints: {
            desktop: '(min-width: 1025px)',
            tablet: '(min-width: 769px) and (max-width: 1024px)',
            mobile: '(min-width: 481px) and (max-width: 768px)',
            smallMobile: '(max-width: 480px)'
        },

        /**
         * Mapeo de breakpoints a número de items por fila
         */
        itemsPerRowMap: {
            desktop: 4,
            tablet: 3,
            mobile: 2,
            smallMobile: 1
        },

	   mainWebinar : true,

        /**
         * Inicializa todas las galerías de vídeos en la página
         * Se ejecuta cuando el DOM está completamente cargado
         */
        init() {
            // Buscar todos los elementos de datos JSON de vídeos
            const videoDataElements = document.querySelectorAll('.vd-webinars-data');
            
            // Inicializar cada galería
            videoDataElements.forEach((element) => {
                const carouselId = element.dataset.carouselId;
                if (carouselId) {
                    this.initCarousel(carouselId, element);
                }
            });

		  // Escuchar cambios de tamaño de ventana para recompute de layout
            window.addEventListener('resize', () => this.handleResize());
        },

	   /**
         * Inicializa un carrousel individual
         * 
         * @param {string} carouselId - ID único del carrousel
         * @param {HTMLElement} dataElement - Elemento que contiene JSON de vídeos
         */
        initCarousel(carouselId, dataElement) {
            try {
                // Parsear datos JSON de vídeos
                const videosData = JSON.parse(dataElement.textContent);
                const { webinars, parametters } = videosData;

                if (!Array.isArray(webinars) || webinars.length === 0) {
                    console.warn('[WebinarsGallery] No Webinars found for carousel:', carouselId);
                    return;
                }

			// Obtener el contenedor del carrousel
			const carouselContainer = document.querySelector('#webinars-section-phergal_webinars_module #carousel-container');

                if (!carouselContainer) {
                    console.warn('[WebinarsGallery] Carousel container not found for ID:', carouselId);
                    return;
                }

                // Crear instancia de carrousel
                const instance = {
                    id: carouselId,
                    container: carouselContainer,
                    videos: webinars,
                    parametters: parametters,
				itemsPerRow: this.getItemsPerRow(),
                    isDragging: false
                };

                // Almacenar la instancia
                this.instances[carouselId] = instance;

                // Renderizar vídeos inicialmente
                this.render(instance);

                //Eliminar el foco de otras cards al hacer hover en una card
                const cards = document.querySelectorAll('#webinars-section-phergal_webinars_module #carouselWebinars');

                cards.forEach(card => {
                    card.addEventListener('mouseenter', () => {
                        const active = document.activeElement;

                        if (active && !card.contains(active)) {
                        active.blur();
                        }
                    });
                });

            } catch (error) {
                console.error('[VideosGallery] Error initializing carousel:', error);
            }
        },

	   /**
         * Renderiza los vídeos en el contenedor
         * Genera HTML para cada vídeo y maneja la visibilidad según paginación
         * 
         * @param {Object} instance - Instancia del carrousel
         */
        render(instance) {
            const { container, videos, parametters, itemsPerRow } = instance;

            // Limpiar contenedor
            container.innerHTML = '';

		  const wrapperDiv = document.createElement('DIV');
		  wrapperDiv.className = "carousel-wrapper";

		  const buttonLeftDiv = document.createElement('BUTTON');
		  buttonLeftDiv.className = "carousel-btn left";
		  buttonLeftDiv.textContent = "‹";
		  
		  buttonLeftDiv.addEventListener("click", () => {
			this.moveCarousel(-1);
		  });

		  const carruselDiv = document.createElement('DIV');
		  carruselDiv.className = "carousel";
		  carruselDiv.id = "carouselWebinars";

		  const buttonRightDiv = document.createElement('BUTTON');
		  buttonRightDiv.className = "carousel-btn right";
		  buttonRightDiv.textContent = "›";
		  
		  buttonRightDiv.addEventListener("click", () => {
			this.moveCarousel(1);
		  });

            // Generar HTML para cada vídeo
            videos.forEach((video) => {
			if (this.mainWebinar) {
				const cardMainHTML = this.createMainVideoCard(video, parametters);			
				
				const tempMainDiv = document.createElement('DIV');
				tempMainDiv.className = "video-principal-container";				
				tempMainDiv.innerHTML = cardMainHTML;
				container.appendChild(tempMainDiv);

				this.mainWebinar = false;
			}

			const cardHTML = this.createVideoCard(video, parametters);

			const tempDiv = document.createElement('DIV');
			tempDiv.className = "carousel-item";
			tempDiv.id = `webinar-${this.escapeHtml(video.id)}`;
			tempDiv.innerHTML = cardHTML;
			
			tempDiv.addEventListener("click", () => {
				this.cambiarVideo(video, parametters);
			});
			
			carruselDiv.appendChild(tempDiv);
            });

		  if (videos.length > itemsPerRow) { 
			wrapperDiv.appendChild(buttonLeftDiv);
		  }
		  
		  wrapperDiv.appendChild(carruselDiv);

		  if (videos.length > itemsPerRow) { 
		  	wrapperDiv.appendChild(buttonRightDiv);
		  }

		  container.appendChild(wrapperDiv);

		  this.mainWebinar = true;
        },

	    /**
         * Genera el HTML de una tarjeta de vídeo
         * Incluye todos los elementos accesibles (aria-labels, roles, etc.)
         * 
         * @param {Object} video - Objeto con datos del vídeo
         * @param {boolean} isVisible - Si la tarjeta debe ser visible
         * @returns {string} HTML de la tarjeta
         */
	   createMainVideoCard(video, parametters) {
            // Formatear fecha
            const dateObj = new Date(video.date);
            const formatter = new Intl.DateTimeFormat('es-ES', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
            const formattedDate = formatter.format(dateObj);

            // Constructor HTML con template literals
		  return `
		  	<video id="videoPrincipal" controls poster="${this.escapeHtml(parametters.url_path)}/webinars/${this.escapeHtml(video.image)}">
                    <source src="${this.escapeHtml(parametters.url_path)}/webinars/${this.escapeHtml(video.url)}" type="video/mp4">
               </video>

               <div class="video-info">
                    <h3 id="tituloVideo">${this.escapeHtml(video.title)}</h3>
                    <p class="metaVideo">
                        <span class="vd-brand">${this.escapeHtml(video.brandname)}</span> ·
                        <time datetime="${this.escapeHtml(video.date)}">${formattedDate}</time>
                    </p>
                    <!--<p id="descVideo"></p>-->
               </div>
		  `;
        },


	   /**
         * Genera el HTML de una tarjeta de vídeo
         * Incluye todos los elementos accesibles (aria-labels, roles, etc.)
         * 
         * @param {Object} video - Objeto con datos del vídeo
         * @param {boolean} isVisible - Si la tarjeta debe ser visible
         * @returns {string} HTML de la tarjeta
         */
        createVideoCard(video, parametters) {
            // Formatear fecha
            const dateObj = new Date(video.date);
            const formatter = new Intl.DateTimeFormat('es-ES', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
            const formattedDate = formatter.format(dateObj);

            // Constructor HTML con template literals
		  return `
			<div class="wi-thumb">
				<img src="${this.escapeHtml(parametters.url_path)}/webinars/${this.escapeHtml(video.thumbnail)}" alt="" loading="lazy" width="200" height="113" />
				${parametters.show_duration ? `<span class="vd-duration">${this.escapeHtml(video.duration)}</span>` : ''}
				<span class="vd-play" aria-hidden="true">▶</span>
			</div>
			<p class="titulo-miniatura">${this.escapeHtml(video.title)}</p>
			<p class="metaVideo-miniatures">
				${parametters.show_brand ? `<span class="vd-brand">${this.escapeHtml(video.brandname)}</span> · ` : ''}
				<time datetime="${this.escapeHtml(video.date)}">${formattedDate}</time> 
			</p>
		  `;
        },

	    /**
         * Carga el video en el contenedor principal
         * 
         * @param {Object} video - Objeto con datos del vídeo
	    * @param {Object} parametros - Objeto con parametros del vídeo
         */
	   cambiarVideo(video, parametters) {
		// Formatear fecha
		const dateObj = new Date(video.date);
		const formatter = new Intl.DateTimeFormat('es-ES', {
			year: 'numeric',
			month: 'short',
			day: 'numeric'
		});
		const formattedDate = formatter.format(dateObj);
		
		const mainVideo = document.getElementById("videoPrincipal");
		const tituloEl = document.getElementById("tituloVideo");
		const brand = document.querySelector(".metaVideo .vd-brand");
		const publish = document.querySelector(".metaVideo time");
		//const descEl = document.getElementById("descVideo");

		mainVideo.src = `${this.escapeHtml(parametters.url_path)}/webinars/${this.escapeHtml(video.url)}`;
		mainVideo.poster = `${this.escapeHtml(parametters.url_path)}/webinars/${this.escapeHtml(video.image)}`;
		tituloEl.textContent = this.escapeHtml(video.title);
		brand.textContent = this.escapeHtml(video.brandname);
		publish.textContent = formattedDate;
		publish.datetime = this.escapeHtml(video.date);
		//descEl.textContent = desc;

		mainVideo.pause();
		mainVideo.load();
		mainVideo.play();
	   },

	   /**
         * Carga el video en el contenedor principal
         * 
         * @param {Integer} direccion - Indica hacia donde se mueve el carrousel
         */
	   moveCarousel(direction) {
		const carousel = document.getElementById("carouselWebinars");
		carousel.scrollLeft += direction * 250;
	   },

	   /**
         * Escapa caracteres especiales HTML para evitar XSS
         * Utilizado en template literals para sanitizar datos
         * 
         * @param {string} text - Texto a escapar
         * @returns {string} Texto escapado
         */
        escapeHtml(text) {
            const map = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#039;'
            };
            return String(text).replace(/[&<>"']/g, (char) => map[char]);
        },

	   /**
         * Maneja el redimensionamiento de ventana
         * Recalcula el layout y re-renderiza si es necesario
         */
        handleResize() {
            const newItemsPerRow = this.getItemsPerRow();

            // Recalcular todas las instancias
            Object.values(this.instances).forEach((instance) => {
                if (instance.itemsPerRow !== newItemsPerRow) {
                    // El layout ha cambiado, ajustar y re-renderizar
                    instance.itemsPerRow = newItemsPerRow;
                    
                    this.render(instance);
                }
            });
        },

	   /**
         * Determina el número de items por fila según el breakpoint actual
         * Utiliza matchMedia para coincidencia de media queries
         * 
         * @returns {number} Número de items por fila (4, 3, 2 o 1)
         */
        getItemsPerRow() {
            for (const [breakpoint, itemsCount] of Object.entries(this.itemsPerRowMap)) {
                if (window.matchMedia(this.breakpoints[breakpoint]).matches) {
                    return itemsCount;
                }
            }
            // Fallback a desktop
            return 4;
        }
	}


    /**
     * Inicializador: espera a que el DOM esté listo
     * Soporta múltiples estados de documento
     */
    function initWhenReady() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                WebinarGallery.init();
            });
        } else {
            // DOM ya está cargado (en AJAX, page reload, etc.)
            WebinarGallery.init();
        }
    }

    // Iniciar cuando esté listo
    initWhenReady();

})();